export default __webpack_public_path__ + "static/media/wh_ep1_tutorial_006.9b6e4479.jpg";